import { render, staticRenderFns } from "./verify_new_user.vue?vue&type=template&id=604d0e58&scoped=true&"
import script from "./verify_new_user.vue?vue&type=script&lang=js&"
export * from "./verify_new_user.vue?vue&type=script&lang=js&"
import style0 from "./verify_new_user.vue?vue&type=style&index=0&id=604d0e58&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604d0e58",
  null
  
)

export default component.exports